class Cache {
  temp = {};
  empty_obj = {};
  empty_array = [];

  get = key => {
    return this.temp[key];
  };

  set = (key, value) => {
    this.temp[key] = value;
  };

  remove = key => {
    delete this.temp[key];
  };

  clear = () => {
    this.temp = {};
  };
}

export const cache = new Cache();



// WEBPACK FOOTER //
// ./src/utils/cache.js